import { z } from "zod";

export const vehicleTypeSchema = z.enum(["SHARED", "PERSONAL", "OUT_OF_FLEET"]);
export type VehicleType = z.infer<typeof vehicleTypeSchema>;

export const vehicleStatusSchema = z.enum([
  "ORDERED",
  "IN_CIRCULATION",
  "DEACTIVATED",
]);
export type VehicleStatus = z.infer<typeof vehicleStatusSchema>;

export const vehicleConnectionStatusSchema = z.enum([
  "APPROVED",
  "CONNECTED",
  "IDLE",
  "PENDING",
  "REJECTED",
  "REVOKED",
]);

export const telemetryDataProviderSchema = z.enum(["FLESPI", "HIGH_MOBILITY"]).nullable();

export const registrationDataSchema = z.object({
  accountProviderId: z.string(),
  phoneNumber: z.string(),
  address: z.object({
    addressLine1: z.string(),
    addressLine2: z.string().nullable().optional(),
    city: z.string(),
    postalCode: z.string(),
    country: z.string(),
  }),
});

export type TelemetryDataProvider = z.infer<typeof telemetryDataProviderSchema>;

export type VehicleConnectionStatus = z.infer<
  typeof vehicleConnectionStatusSchema
>;
